<div
  class="notification"
  *ngIf="flashMessage"
  [ngClass]="flashMessage.className"
>
  <p><i class="icon is-bold icon-bell p-r-md"></i>{{ flashMessage.message }}</p>
</div>
